import { useContext, useState } from 'react';
import { Context } from '../../lib/Context';
import '../../lib/css/AddEventModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';
import AddSingleCompetitor from './ModalElements/AddSingleCompetitor';
import AddMultipleCompetitors from './ModalElements/AddMultipleCompetitors';
import { parseCSV, parseCompetitorCSV } from '../../lib/Functions/parseCSV';
import { apiCall } from '../../lib/Functions/apiClient';
import BaseModal from './BaseModal';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';


const AddCompetitorsModal = () => {
    const { API_LINK, showAddCompetitorModal, setShowAddCompetitorModal, setAddCompetitorEventID, addCompetitorEventID,
        setEvents, setShowAlert, setAlertObject
    } = useContext(Context);
    const [addIndividual, setAddIndividual] = useState(false);
    const [competitors, setCompetitors] = useState([]);
    const [email, setEmail] = useState('');
    const [age, setAge] = useState('');
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [gender, setGender] = useState('Male');
    const [tagNumber, setTagNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [csv, setCsv] = useState(null);

    const checkDataIsValid = () => {
        if (addIndividual) {
            if (!(firstname.length > 0 && lastname.length > 0 && tagNumber.length > 0 &&
                (age !== 0 || age !== ''))) {
                setShowAlert(true);
                let alertMessage = {
                    variant: 'danger',
                    text: 'All of the data needs to be filled in before you can submit.'
                }
                setAlertObject(alertMessage);
            }
            return firstname.length > 0 && lastname.length > 0 && tagNumber.length > 0 &&
                (age !== 0 || age !== '')
        } else {
            if (!csv) {
                setShowAlert(true);
                let alertMessage = {
                    variant: 'danger',
                    text: 'Please add a CSV file to the input.'
                }
                setAlertObject(alertMessage);
            }
            return csv
        }

    }

    const addCompetitors = async () => {
        // Perform check to ensure all the data is present before continuing.
        if (checkDataIsValid()) {
            setIsLoading(true);
            await apiCall('/add-competitors', {
                method: 'POST',
                body: { competitors, eventID: addCompetitorEventID },
                apiLink: API_LINK,
                onSuccess: (data) => {
                    if (data.error) {
                        console.log('There was an error: ' + data.error);
                    } else {
                        if (data.adjudicatorFound) {
                            setShowAlert(true);
                            let alertMessage = {
                                variant: 'danger',
                                text: 'You can\'t add adjudicators as competitors to an event.'
                            }
                            setAlertObject(alertMessage);
                        } else {
                            setEmail('');
                            setAge(0);
                            handleClose();
                        }
                        setEvents(data.events);
                    }
                    setIsLoading(false);
                },
                onError: (error) => {
                    console.error('Error adding competitors:', error);
                    setIsLoading(false);
                }
            });
        }
    }

    const handleSelectGender = (eventGender) => {
        setGender(eventGender);
    }

    const handleAddData = (event) => {
        let type = event.target.name;
        let value = event.target.value;
        switch (type) {
            case 'email':
                setEmail(value);
                break;
            case 'age':
                setAge(value);
                break;
            case 'firstname':
                setFirstname(value);
                break;
            case 'lastname':
                setLastname(value);
                break;
            case 'tag_number':
                setTagNumber(value);
                break;
            default:
                break;
        }
        let singleCompetitor = [];
        singleCompetitor.push({ email, age, firstname, lastname, tag_number: tagNumber, gender })
        setCompetitors(singleCompetitor);
    }

    const addFile = (event) => {
        const file = event.target.files[0];
        setCsv(file);
        if (file) {
            parseCSV(file, {
                onComplete: (csvData) => {
                    const competitors = parseCompetitorCSV(csvData);
                    setCompetitors(competitors);
                },
                onError: (error) => {
                    console.error("Error parsing the CSV file:", error);
                }
            });
        }
    }

    const handleClose = () => {
        setShowAddCompetitorModal(false);
        setAddCompetitorEventID('');
        setCsv(null);
        setTimeout(() => {
            setAddIndividual(false);
        }, "200");
    };

    const toggleAddIndividual = () => {
        setAddIndividual(!addIndividual);
    }

    return (
        <BaseModal
            show={showAddCompetitorModal}
            onHide={handleClose}
            title={`Add ${addIndividual ? 'Competitor' : 'Competitors'} to Event`}
            footer={
                <div style={{ width: '100%' }}>
                    <button className="white-glow-button float-left" style={{ float: 'left' }} onClick={toggleAddIndividual}>
                        <FontAwesomeIcon icon={faRetweet} /> Add {addIndividual ? 'Multiple' : 'Single'}
                    </button>
                    <button className="green-glow-button float-right" onClick={addCompetitors} style={{ width: '200px' }}>
                        {!isLoading ? `Add ${addIndividual ? 'Competitor' : 'Competitors'}`
                            :
                            <Spinner animation="border" size="sm" />
                        }
                    </button>
                </div>
            }
        >
            {addIndividual ?
                <AddSingleCompetitor
                    handleAddData={handleAddData}
                    age={age === 0 ? '' : age}
                    email={email}
                    firstname={firstname}
                    lastname={lastname}
                    gender={gender}
                    tagNumber={tagNumber}
                    handleSelectGender={handleSelectGender}
                />
                :
                <AddMultipleCompetitors addFile={addFile} />
            }
            <Form.Text id="info-block" muted >
                <span style={{ color: 'white', marginTop: '10px', fontStyle: 'italic' }}>
                    NOTE: If you try to add an adjudicator here you will get an error message
                    as you can't register an adjudicator as a competitor{addIndividual && '.'} {!addIndividual &&
                        ' but any non adjudicator competitors you try to add will be added despite the warning.'}
                </span>
            </Form.Text>
        </BaseModal>
    );
}

export default AddCompetitorsModal;